/* Native form submission remains usable before this enhancement loads. */
if (!customElements.get('dr-service-selector')) {
  customElements.define(
    'dr-service-selector',
    class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', (event) => {
          if (event.target.closest('a, button, input, label')) return;
          const card = event.target.closest('.dr-card-wrapper');
          const radio = card?.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
        });
        this.addEventListener('submit', (event) => {
          const card = event.submitter?.closest('.dr-card-wrapper');
          const radio = card?.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
        });
      }
    },
  );
}
